import '../vendor/magnific-popup.js';
import '../vendor/slick.js';

(function ($) {
  // Video Carousel
  $('[video-slider]').each(function () {
    $(this).slick({
      mobileFirst: true,
      slidesToShow: 1,
      arrows: true,
      prevArrow: $(this).parent().find('.slick-prev'),
      nextArrow: $(this).parent().find('.slick-next'),
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
  });

  // Video Modal
  $('[video-modal]').on('click', function (e) {
    const id = $(this).attr('data-modal');
    const src = document.getElementById(id);
    const iframe = src.querySelector('iframe');
    $.magnificPopup.open({
      items: {
        src: src,
        type: 'inline',
      },
      callbacks: {
        beforeOpen: function () {
          const url = iframe.getAttribute('data-src');
          iframe.src = url;
        },
        beforeClose: function () {
          iframe.removeAttribute('src');
        },
      },
    });
  });
})(jQuery);
